export default "__VITE_ASSET__6mSpC0rS__"